import axios, { AxiosHeaders, AxiosInstance, AxiosResponse, InternalAxiosRequestConfig } from "axios";
import qs from "qs";
import moment from "moment";
import { serviceUrl } from "../config/constants";
import { requestTimeout } from "../redux/constants";

export type HttpError = {
    status: any,
    message: string,
};

export type Release = {
    name: string,
    version: number,
    date: string,
    showNewVersionToEveryone: boolean,
};

export let apiService: AxiosInstance;

const initApiService = () => {
    apiService = axios.create({
        baseURL: serviceUrl + '/api',
        timeout: requestTimeout,
        paramsSerializer: (params: any) =>
            qs.stringify(
                params,
                {
                    encodeValuesOnly: true,
                    arrayFormat: "comma",
                    allowDots: true,
                    indices: false,
                    serializeDate: (date: Date) => {
                        return moment(date).format("YYYY-MM-DDTHH:mm:ss");
                    },
                }
            )
    });

    apiService.interceptors.request.use(
        (config: InternalAxiosRequestConfig) => {
            if (config.withCredentials) config.withCredentials = undefined; // Para não causar problema de CORS

            config.headers = (config.headers ? config.headers : new AxiosHeaders()) as AxiosHeaders;

            if (!config.headers.get("X-Requested-With")) config.headers.set("X-Requested-With", "XMLHttpRequest");

            if (!config.headers.get("Content-Type")) config.headers.set("Content-Type", "application/json");

            const token = localStorage.getItem("app.token");
            if (token) config.headers.set("Authorization", `Bearer ${token?.replaceAll('"', '')}`);

            return config;
        },
        (error: any) => {
            return Promise.reject(error);
        }
    );

    apiService.interceptors.response.use(
        (response: AxiosResponse) => {
            return response;
        },
        (error: any) => {
            return Promise.reject(error);
        }
    );

    return { apiService };
};

export const APIService = {
    init: initApiService,
};
